module.exports = __webpack_public_path__ + "img/solution.cf460dc9.svg";